import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const ContactQueryService = {
  actions: {
    fetchAllReleases ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/releases',
          method: 'GET'
        })
          .then(resp => {
            const releases = resp.data.releases
            commit('api_success')
            resolve(resp)
            return releases
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    createRelease ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/release',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteRelease ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/release/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    editRelease ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/release/' + data.get('id'),
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    fetchRelease ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/release/' + id,
          method: 'GET'
        })
          .then(resp => {
            const release = resp.data.release
            commit('api_success')
            resolve(resp)
            return release
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default ContactQueryService



// WEBPACK FOOTER //
// ./src/services/releaseService.js